import { eTemplatesTable } from 'src/pages/WhatsappApi/components/TemplatesTable/TemplatesTable.enum';
import { tTemplateTable } from 'src/pages/WhatsappApi/components/TemplatesTable/TemplatesTable.types';

/**
 * INT-1504: messaging's retry refusal reasons (BUG-908) that call for their
 * own copy. Every other reason means the message cannot be retried at all.
 */
const RETRY_REFUSAL_COPY: Record<string, string> = {
  retry_cooldown: 'retry.tooSoon',
  workspace_rate_limited: 'retry.tooSoon',
  rate_limiter_unavailable: 'retry.tooSoon',
  attempt_ceiling_reached: 'retry.tooManyAttempts',
};

function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === 'object' && value !== null;
}

/**
 * The toast copy key for a failed retry request.
 *
 * - 409: another retry claimed the message first.
 * - 422: messaging declined; its `reason` picks the copy.
 * - 404: no such failed message in this chat.
 * - anything else (no response, 424, 5xx): the request itself failed.
 *
 * A 423 (paused workspace) never gets here: the caller shows the shared
 * outbound-refusal toast for it.
 */
export function retryRefusalCopyKey(error: unknown): string {
  const response =
    isRecord(error) && isRecord(error.response) ? error.response : undefined;
  const status = response?.status;
  const reason = isRecord(response?.data) ? response.data.reason : undefined;

  if (status === 409) return 'retry.inProgress';
  if (status === 422) {
    return (typeof reason === 'string' && RETRY_REFUSAL_COPY[reason]) ||
      'retry.notRetryable';
  }
  if (status === 404) return 'retry.notRetryable';
  return 'retry.failed';
}

/**
 * INT-1500 U2 (D5): whether the workspace has a follow-up template Meta
 * approved (UTILITY). Without one, "Elegir plantilla de seguimiento" would
 * open an empty picker, so the notice offers to create one instead.
 */
export function hasApprovedUtilityTemplate(
  templates: ReadonlyArray<Pick<tTemplateTable, 'template_type' | 'status'>>,
): boolean {
  return templates.some(
    (template) =>
      template.template_type === 'UTILITY' &&
      template.status === eTemplatesTable.APPROVED,
  );
}
